module.exports = __webpack_public_path__ + "img/avatar-s-12.9b7e1e0f.jpg";